// BUG-2372: payment-data-popup fields (paymentMethod.paymentDataFields) captured per
// payment line are also written into the order-level "Payment Details" meta (s_order_meta),
// in the same {name: value} object shape that array already uses for tender amounts,
// Bill Amount, change, etc. If two tenders on the same bill carry the same field, the later
// one is suffixed with its payment-method name so neither value is lost.
export const buildPaymentDataDetails = (payments) => {
  const used = new Set();
  const out = [];
  for (const payment of payments || []) {
    for (const f of payment?.paymentData || []) {
      if (!f?.fieldKey || f.fieldValue === undefined || f.fieldValue === null || f.fieldValue === "") continue;
      let key = f.fieldKey;
      if (used.has(key)) key = `${f.fieldKey} (${payment.name || payment.finPaymentmethodId})`;
      if (used.has(key)) continue;
      used.add(key);
      out.push({ [key]: String(f.fieldValue) });
    }
  }
  return out;
};

// BUG-2372: Card (manual) and Bank Transfer carry their reference on the payment line's
// transactionId/transactionTime (fin_receiptplan_details.transaction_id/transaction_time,
// shown in Backoffice Payment Plan details). Derive the same two values from captured
// payment-data fields: the reference is the first text/number field whose key or name
// looks like a transaction/reference/UTR id (else the first text field); the time is the
// first date/datetime field.
const REFERENCE_NAME = /transaction|reference|ref\b|utr|txn/i;
export const pickPaymentDataReference = (paymentData) => {
  const filled = (paymentData || []).filter((f) => f && f.fieldValue !== undefined && f.fieldValue !== null && f.fieldValue !== "");
  const isText = (f) => !f.fieldType || f.fieldType === "STR" || f.fieldType === "NUM";
  const isDate = (f) => f.fieldType === "DAT" || f.fieldType === "DTM";
  const ref =
    filled.find((f) => isText(f) && !isDate(f) && REFERENCE_NAME.test(`${f.fieldKey || ""} ${f.fieldName || ""}`)) ||
    filled.find((f) => f.fieldType === "STR");
  const date = filled.find(isDate);
  return {
    transactionId: ref ? String(ref.fieldValue) : null,
    transactionTime: date ? String(date.fieldValue) : null,
  };
};

// Enriches one posOrderProcessor payments[] line in place with the captured fields: appends
// them to its metaData and fills transactionId/transactionTime only where the line has none,
// so Card/Bank Transfer/Wallet values set by their own branches are never overwritten.
export const applyPaymentDataToLine = (line, paymentData) => {
  if (!line || !paymentData?.length) return line;
  line.metaData = [...(line.metaData || []), ...paymentData.map((f) => ({ key: f.fieldKey, value: f.fieldValue }))];
  const ref = pickPaymentDataReference(paymentData);
  if (line.transactionId == null && ref.transactionId) line.transactionId = ref.transactionId;
  if (line.transactionTime == null && ref.transactionTime) line.transactionTime = ref.transactionTime;
  return line;
};
